var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalinfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".Icon",
    clipPath: "url(#clip0_427_8915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.5527 21.6278V19.6278C23.5521 18.7415 23.2571 17.8806 22.7141 17.1801C22.1711 16.4797 21.4109 15.9794 20.5527 15.7578",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5527 21.627V19.627C17.5527 18.5661 17.1313 17.5487 16.3812 16.7985C15.631 16.0484 14.6136 15.627 13.5527 15.627H5.55273C4.49187 15.627 3.47445 16.0484 2.72431 16.7985C1.97416 17.5487 1.55273 18.5661 1.55273 19.627V21.627",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5527 3.75781C17.4131 3.97811 18.1758 4.47851 18.7204 5.18012C19.265 5.88173 19.5606 6.74464 19.5606 7.63281C19.5606 8.52098 19.265 9.38389 18.7204 10.0855C18.1758 10.7871 17.4131 11.2875 16.5527 11.5078",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.55273 11.627C11.7619 11.627 13.5527 9.83609 13.5527 7.62695C13.5527 5.41781 11.7619 3.62695 9.55273 3.62695C7.3436 3.62695 5.55273 5.41781 5.55273 7.62695C5.55273 9.83609 7.3436 11.627 9.55273 11.627Z",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_8915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.552734 0.626953)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalinfoIcon);
export default __webpack_public_path__ + "static/media/personalinfo_icon.6da91d0f800dc716af15d07ad88bd56b.svg";
export { ForwardRef as ReactComponent };